import React from "react";
import { useSelector } from "react-redux";
import {
  getElementById,
  getContainerClass,
  getLabelStyles,
  getInputStyles,
} from "../utils/styleUtils";

export const CustomTimePicker = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Time picker element not found</div>;
  }

  const elementStyle = element.style || {};
  const labelPosition = elementStyle.labelPosition || "top";

  const handleTimeChange = (e) => {
    if (field && form) {
      form.setFieldValue(field.name, e.target.value);
    }
  };

  return (
    <div className={getContainerClass(labelPosition)} style={{ width: "100%" }}>
      {elementStyle.label?.label && (
        <label
          htmlFor={`time-${instanceId}`}
          style={getLabelStyles(elementStyle, labelPosition)}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <div className="position-relative">
        <input
          id={`time-${instanceId}`}
          type="time"
          value={field?.value || ""}
          onChange={handleTimeChange}
          required={elementStyle.isRequired}
          min={elementStyle.minTime}
          max={elementStyle.maxTime}
          step={elementStyle.step || "60"}
          style={getInputStyles(elementStyle, labelPosition)}
          className="form-control"
          {...props}
        />
        <i
          className="bi bi-clock position-absolute"
          style={{
            top: "50%",
            right: "0.75rem",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            color: "#6c757d",
          }}
        ></i>
      </div>

      {elementStyle.helpText && (
        <small className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
          {elementStyle.helpText}
        </small>
      )}
    </div>
  );
};
